import { takeEvery, put, call } from 'redux-saga/effects';
import { basketActionsTypes } from '../../types/basket';

import { updatAsapTime } from '../../../services/basket';
import { createBasketAsapTimeFailure, createBasketAsapTimeSuccess } from '../../actions/basket/create';
// import { addSingleProduct } from '../../../../../services/basket';

function* asyncUpdatAsapTime(action: any): any {
    // debugger;
  try {
    const response = yield call(
        updatAsapTime,
      action.basketid,
    );
    // debugger;
    yield put(createBasketAsapTimeSuccess(response.data));
  } catch (error) {
    yield put(createBasketAsapTimeFailure(error));
  }
}

export function* addAsapTimeSaga() {
  yield takeEvery(
    basketActionsTypes.SET_BASKET_ASAP_TIME,
    asyncUpdatAsapTime,
  );
}
